import {
    FETCH_NOTES_REQUEST,
    GET_EMPTY_NOTE,
    GET_TAG_TYPES,
    NOTES_ERROR,
} from '../ActionTypes';

const initActions = function (services) {
    const axiosCall = services.axios.Axios();

    const getEmptyNote = (note) => {
        return {
            type: GET_EMPTY_NOTE,
            payload: note,
        };
    };
    
    const fetchNotesRequest = () => {
        return {
            type: FETCH_NOTES_REQUEST,
        };
    };
    
    const notesError = (error) => {
        return {
            type: NOTES_ERROR,
            payload: error,
        };
    };

    const getTagTypes = (tags) => {
        return {
            type: GET_TAG_TYPES,
            payload: tags,
        };
    };
    
    const fetchNotes = (practiceID, pageNumber) => {
        if (!pageNumber) {
            pageNumber = 1;
        }
        return async (dispatch) => {
            try {
                dispatch(fetchNotesRequest);
                var response = await axiosCall.get(
                    `practices/${practiceID}/notes?pageSize=1000&pageNumber=${pageNumber}`
                );
                const notes = response.data.data.items;
                return notes;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(notesError(errorMsg));
            }
        };
    };

    const fetchEmptyNote = () => {
        return async (dispatch) => {
            try {
                dispatch(fetchNotesRequest);
                var response = await axiosCall.get(`notes/empty`);
                const emptyNote = response.data.data;
                const tagTypes = emptyNote.tagGroups;
                dispatch(getEmptyNote(emptyNote));
                dispatch(getTagTypes(tagTypes));
            } catch (error) {
                const errorMsg = error.message;
                dispatch(notesError(errorMsg));
            }
        };
    };

    const getTags = () => async () => axiosCall.get('notes/tags');
    
    const createNote = (payload) => async () =>
        axiosCall.post('notes', payload);

    const getNotes = (practiceId) => async () =>
        axiosCall.get('notes', { params: { practiceId: practiceId } });

    return {
        createNote,
        fetchEmptyNote,
        fetchNotes,
        fetchNotesRequest,
        getEmptyNote,
        getNotes,
        getTagTypes,
        getTags,
        notesError,
    };
};

export default initActions;
